import { Filter, NormalizePreferFilter, PreferFilterList } from '@/api/types/filters.types';

import { httpClient } from '@/libs/http-client';

export class FilterApi {
  static filterDataExtractor = ({ id, title }: Filter) => {
    return {
      value: id,
      label: title,
    };
  };

  // =================================================================

  static normalizeFilterData = (filter: PreferFilterList): NormalizePreferFilter => {
    const [minYear, maxYear] = [filter.years.from, filter.years.to];
    const years = Array.from({ length: maxYear - minYear + 1 }, (_, i) => {
      const year = maxYear - i;
      return { id: year, title: String(year) };
    });

    return {
      genres: filter.genres.map(filter => FilterApi.filterDataExtractor(filter)),
      countries: filter.countries.map(filter => FilterApi.filterDataExtractor(filter)),
      yearFrom: years.map(filter => FilterApi.filterDataExtractor(filter)),
      yearTo: years.map(filter => FilterApi.filterDataExtractor(filter)),
      qualities: filter.qualities.map(filter => FilterApi.filterDataExtractor(filter)),
      cinemas: filter.cinemas.map(filter =>
        FilterApi.filterDataExtractor({
          id: filter.slug_name,
          title: filter.title,
        }),
      ),
    };
  };

  // =================================================================

  static fetchPreferedFilterList = async () => {
    const { data } = await httpClient.get<PreferFilterList>('/content/prefer-filter');

    return FilterApi.normalizeFilterData(data);
  };
}
